import { priceListUrl } from '../../../constants/urls';
import { formatDate } from '../../../utils/date';
import GenericList from '../../../components/List';
import { useNavigate } from 'react-router-dom';

const mapPriceListData = (data) => {
  const list = Array.isArray(data) ? data : [];
  return list.map((item) => ({
    id: item.id,
    titulo: item.nombre,
    fecha_ultima_actualizacion: formatDate(item.fecha_actualizacion),
  }));
};

const columns = [
  { field: 'titulo', headerName: 'Título', flex: 1, align: 'center', headerAlign: 'center' },
  { field: 'fecha_ultima_actualizacion', headerName: 'Última Actualización', flex: 1, align: 'center', headerAlign: 'center', mobileHeaderName: 'Ult. Actualización' },
];

const data = {
  title: 'Listas de Precios',
  subtitle: 'Gestioná las listas y sus precios por bulto y por unidad.',
  deleteSuccessMessage: (count) =>
    count === 1 ? 'La lista de precios se eliminó correctamente.' : `Se eliminaron ${count} listas de precios correctamente.`,
  fetchUrl: {
    baseUrl: priceListUrl,
    createUrl: '/price-list/create',
    editUrl: '/price-list/edit',
    detailUrl: '/price-list/detail',
  },
  columns,
  mapData: mapPriceListData,
  filtersConfig: [
    { label: 'Nombre', name: 'nombre', type: 'text' },
  ],
  newLabelText: 'Nueva lista',
};

const PriceListList = () => {
  const navigate = useNavigate();

  const handleAdd = () => {
    navigate('/price-list/create');
  };

  return <GenericList data={data} onAdd={handleAdd} />;
};

export default PriceListList;
